<template>
  <HeaderComponent ref="openAuth" />
  <div class="main">
    <Flicking
      :options="{
        renderOnlyVisible: false,
        panelsPerView: isMobile ? 1 : 3,
        circular: false,
        bound: true,
        inputType: ['mouse', 'pointer'],
      }"
      :plugins="carouselPlugins"
      @reachEdge="reloadCarousel"
      ref="flick"
    >
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/8K4G9AkdYrjyFYhdOEz_4Q.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/gV3vLAXxr5qVDTJywAXlGA.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/TvpysNMGZ1AZ_xOlkeDpcw.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/c_HgBp24KWHObVoZ9MnRhA.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/OqAJ1jLfk3pfhrrGYxNr4A.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/dqfx_9FHZvjkLG1RSafQlw.jpg" />
      <img class="flicking-panel" src="https://cdn.xxximageur.com/f/His6gaEye821h2DgBUYwMg.jpg" />

      <template #viewport>
        <div class="flicking-pagination"></div>
      </template>
    </Flicking>
    <div class="questionnaires">
      <div class="headQuestionnaires">
        <p>Анкеты</p>
        <div class="online">
          <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 0 0 -1 0 7.5)" fill="#2ECC71" />
          </svg>
          <p>{{ onlineGirls }} онлайн</p>
        </div>
      </div>
      <div class="mainQuestionnaires">
        <div class="filtersQuestionnaires">
          <!-- <div class="filterQuestionnaires">
            <p>Новые анкеты</p>
          </div> -->
        </div>
        <div class="listQuestionnaires">
          <GirlCard
            v-for="girl in girls"
            :key="girl._"
            :girl="girl"
            :cityName="this.city"
            :linkHref="this.user != null ? `/girl/${girl._id}` : null"
            :buttonLinkHref="this.user != null ? `/girl/${girl._id}` : null"
            @reserve-click="this.user == null ? (!isMobile ? this.callChildFunction() : this.openMainFromMain()) : null"
          />
        </div>
        <a :href="this.user != null ? '/girls/1' : console.log(123)" style="width: 100%; margin-bottom: 7%">
          <button class="allQuestionnaires" @click="this.user == null ? this.callChildFunction() : console.log('Все анкеты')">Все анкеты</button>
        </a>
      </div>
    </div>
    <div class="aboutUs" id="aboutUs">
      <div class="oneText">
        <p>О Sensa</p>
        <p>
          Это онлайн-платформа,<br />предоставляющая пользователям<br />возможность поиска и бронирования<br />специалистов в сфере эскорта,<br />массажа и сопутствующих услуг по<br />всей России.<br /><br />Платформа предлагает удобный<br />интерфейс для взаимодействия<br />между клиентами и<br />профессионалами,
          обеспечивая<br />безопасность и<br />конфиденциальность.
        </p>
      </div>
      <img class="twoText" src="../assets/img/aboutSensa.png" />
      <div class="threeText">
        <img src="../assets/icons/shield.svg" />
        <p class="aboutHeadText">Надежно</p>
        <p class="aboutDescText">Только проверенные<br />и реальные анкеты девушек</p>
      </div>
      <div class="fourText">
        <img src="../assets/icons/clockPink.svg" />
        <p class="aboutHeadText">Быстро</p>
        <p class="aboutDescText">Найдите подходящую девушку<br />рядом с вами в кратчайшие сроки</p>
      </div>
      <div class="fiveText">
        <img src="../assets/icons/schedule.svg" />
        <p class="aboutHeadText">Круглосуточно</p>
        <p class="aboutDescText">Сервис работает 24/7, включая<br />выходные и праздники</p>
      </div>
    </div>
    <div class="mobileAboutUs" id="aboutUs">
      <img class="twoText" src="../assets/img/aboutSensa.png" />
      <div class="oneText">
        <p class="aboutHeadText">О Sensa</p>
        <p class="aboutDescText">
          Это онлайн-платформа,<br />предоставляющая пользователям<br />возможность поиска и бронирования<br />специалистов в сфере эскорта,<br />массажа и сопутствующих услуг по<br />всей России.<br /><br />Платформа предлагает удобный<br />интерфейс для взаимодействия<br />между клиентами и<br />профессионалами,
          обеспечивая<br />безопасность и<br />конфиденциальность.
        </p>
      </div>
      <div class="threeText">
        <img src="../assets/icons/shield.svg" />
        <p class="aboutHeadText">Надежно</p>
        <p class="aboutDescText">Только проверенные<br />и реальные анкеты девушек</p>
      </div>
      <div class="fourText">
        <img src="../assets/icons/clockPink.svg" />
        <p class="aboutHeadText">Быстро</p>
        <p class="aboutDescText">Найдите подходящую девушку<br />рядом с вами в кратчайшие сроки</p>
      </div>
      <div class="fiveText">
        <img src="../assets/icons/schedule.svg" />
        <p class="aboutHeadText">Круглосуточно</p>
        <p class="aboutDescText">Сервис работает 24/7, включая<br />выходные и праздники</p>
      </div>
    </div>
  </div>
  <FooterComponent />
  <div class="citySelectWebApp" v-if="isShowCityWebApp">
    <div class="selectCityBlock">
      <div class="selectCityBlockHead">
        <p>Выберите город для продолжения</p>
      </div>
      <div class="selectCityBlockBody">
        <input class="selectCityInput" @focusin="isShowCityWebAppList = true" readonly v-model="selectedCity" />
        <div class="cityList" v-show="isShowCityWebAppList">
          <p>Города России</p>
          <ul>
            <!-- prettier-ignore -->
            <li
              v-for="city in cityList"
              v-bind:key="city"
              @click="
                selectedCity = city; isShowCityWebAppList = false
              "
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="14" height="14" rx="3" fill="#F3F3F3" />
              </svg>
              {{ city }}
            </li>
          </ul>
        </div>
      </div>
      <button class="reservationButton" @click="regTG">Выбрать</button>
    </div>
  </div>
</template>

<script>
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import GirlCard from "@/components/GirlCard.vue";
import mainGirls from "@/data/mainGirls";
import Flicking from "@egjs/vue3-flicking";
import { Pagination } from "@egjs/flicking-plugins";
import { AutoPlay } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.min.css";
import axios from "axios";
import { ref } from "vue";
import { useWebApp } from "vue-tg";
export default {
  name: "HomeView",
  data() {
    return {
      girls: null,
      carouselSlides: ["https://xapiimagehandler.pro/files/qX3VCcZwSDPL.jpg", "https://xapiimagehandler.pro/files/ZgSUYn11Yoyx.jpg", "https://xapiimagehandler.pro/files/fqtKaiX723pU.jpg"],
      user: this.$store.getters.getUserData,
      onlineGirls: Math.floor(Math.random() * (880 - 870 + 1)) + 870,
      carouselPlugins: [new AutoPlay({ duration: 1500, stopOnHover: true }), new Pagination({ type: "bullet" })],
      isMobile: false,
      city: this.$store.getters.getCity,
      isShowCityWebApp: false,
      isShowCityWebAppList: false,
      selectedCity: null,
      cityList: this.$store.getters.getCityList,
      isHaveCity: false,
    };
  },
  methods: {
    loadGirls() {
      try {
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/girl/new-search`, {
            params: {
              q: "",
              page: 1,
              limit: 6,
            },
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          })
          .then((res) => {
            console.log(res);
            this.girls = res.data.result.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        this.girls = mainGirls;
      }
    },
    getPluralForm(number) {
      let forms = ["год", "года", "лет"];
      number = Math.abs(number) % 100;
      const lastDigit = number % 10;
      if (number > 10 && number < 20) return forms[2];
      if (lastDigit === 1) return forms[0];
      if (lastDigit >= 2 && lastDigit <= 4) return forms[1];
      return forms[2];
    },
    reloadCarousel() {
      setTimeout(() => this.flick.moveTo(1), 1500);
    },
    showSelectCity() {
      this.isShowCityWebApp = true;
    },
    checkTg() {
      if (window.Telegram?.WebApp) {
        var initData = window.Telegram.WebApp.initData;
        if (initData) {
          console.log("Пользователь зашёл через Telegram");
          console.log("вебаппа", useWebApp(), "инитдата", initData);
          this.loginTG();
        } else {
          console.log("initData пустой — возможно, не через Telegram");
        }
      } else {
        console.log("Нет Telegram WebApp — точно не через Telegram");
      }
    },
    async loginTG() {
      try {
        let res = await axios.post(
          `https://${process.env.VUE_APP_SERVERHOST}/api/auth/webapp/login`,
          {
            city: "",
          },
          {
            headers: {
              authorization: useWebApp().initData,
            },
          },
        );
        console.log(res);
        this.$store.commit("setUserData", res.data.result);
        if (res.data.result.cityId) {
          const findCity = this.cityList.find((item) => item === res.data.result.cityId.name);
          this.$store.commit("setCity", findCity);
          console.log("291 строка", findCity, res.data.result.cityId.name, this.cityList);
        } else {
          console.log("ГОРОДА НЕЕЕЕЕЕЕЕЕТ");
          this.showSelectCity();
        }
      } catch (err) {
        console.log(err);
        if (err.status == 401) {
          this.showSelectCity();
        }
      }
    },
    async regTG() {
      if (this.user) {
        axios
          .put(
            `https://${process.env.VUE_APP_SERVERHOST}/api/users/city`,
            {
              cityName: this.selectedCity,
            },
            {
              headers: {
                authorization: `Bearer ${this.user.token}`,
              },
            },
          )
          .then((res) => {
            console.log("ГОРОД СМЕНИЛИ", res);
            const findCity = this.cityList.find((item) => item === res.data.result.cityId.name);
            console.log(findCity, res.data.result.cityId, this.cityList);
            console.log("320 строка");
            this.$store.commit("setCity", findCity);
            window.location.reload();
          })
          .catch((err) => {
            console.log("ГОРОД НЕ СМЕНИЛИ", err);
          });
      } else {
        try {
          let res = await axios.post(
            `https://${process.env.VUE_APP_SERVERHOST}/api/auth/webapp/register`,
            {
              referral: this.$route.query.ref,
              city: this.selectedCity,
            },
            {
              headers: {
                authorization: useWebApp().initData,
              },
            },
          );
          console.log(res);
          this.$store.commit("setUserData", res.data.result);
          // axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/cities`).then((res) => {
          // let user = this.$store.getters.getUserData
          // console.log(user)
          const findCity = this.cityList.find((item) => item === res.data.result.cityId.name);
          console.log("346 строка");
          this.$store.commit("setCity", findCity);
          window.location.reload();
          // })
        } catch (err) {
          console.log(err);
        }
      }
    },
    loadCityList() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/cities`, {
          headers: {
            // Authorization: 'Bearer ' + this.$store.state.userData.token
          },
        })
        .then((res) => {
          this.cityList = res.data.result.map((item) => item.name);
          this.$store.commit("setCityList", this.cityList);
          console.log("ГОРОДА", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.loadGirls();
    this.checkTg();
    this.loadCityList();
    this.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    console.log(this.$store.getters.getCity);
  },
  setup() {
    const openAuth = ref(null);
    const callChildFunction = () => {
      if (openAuth.value) {
        openAuth.value.openAuth();
      }
    };
    const openMainFromMain = () => {
      if (openAuth.value) {
        openAuth.value.openAuth();
      }
    };
    const myCarousel = ref(null);
    const flick = ref();
    return { openAuth, callChildFunction, openMainFromMain, myCarousel, flick };
  },
  components: {
    HeaderComponent,
    FooterComponent,
    GirlCard,
    Flicking,
  },
};
</script>
<style scoped>
.main {
  width: 65vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 3vh;
}
.photoCarousel {
  display: flex;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.photoCarousel img {
  width: 50%;
  border-radius: 10px;
}
.questionnaires {
  width: 100%;
}
.headQuestionnaires {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 2%;
}
.headQuestionnaires p {
  font-size: 32px;
  font-weight: 600;
}
.online {
  justify-self: right;
  display: flex;
  align-items: center;
  gap: 5px;
}
.online p {
  font-size: 16px;
  font-weight: 400;
}
.mainQuestionnaires {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.filtersQuestionnaires {
  display: flex;
  gap: 20px;
  margin-top: 3%;
  margin-bottom: 20px;
}
.filterQuestionnaires {
  background-color: #fbfbfb;
  border-radius: 28px;
  padding: 10px 20px 10px 20px;
  cursor: pointer;
  user-select: none;
  border: 1px solid #f4f4f4;
}
.filterQuestionnaires p {
  font-size: 18px;
}
.choosenFilterQuestionnaires {
  background-color: #2f2f2f;
  color: #ffffff;
}
.listQuestionnaires {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.questionnaire {
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.mainInfoQuestionnaire {
  display: flex;
  height: 80%;
  gap: 20px;
}
.girlPhoto {
  width: 100%;
  height: 100%;
}
.girlPhoto img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.infoGirl {
  width: 70%;
}
.girlName {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
}

.verifyPopUp {
  position: absolute;
  bottom: 125%; /* выше иконки */
  left: 50%;
  transform: translateX(-50%);
  background-color: #2f2f2f;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyPopUp p {
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 500;
}

.verify-wrapper:hover .verifyPopUp {
  opacity: 1;
}
.infoGirl p:nth-child(2) {
  font-size: 14px;
  margin-bottom: 10px;
}
.priceGirl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.featuresGirl {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
}
.pinkFeatures,
.blueFeatures {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pinkFeature {
  background-color: #ff898926;
  color: #ff8989;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  display: flex;
  padding: 5px 7px 5px 7px;
}
.blueFeature {
  background-color: #89bfff26;
  color: #89bfff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 7px 5px 7px;
}
.hourRent {
  display: flex;
  gap: 20px;
}
.infoHour {
  display: flex;
  flex-direction: column;
  color: #2f2f2f;
}
.infoHour span {
  font-family: "Noto Sans";
  display: flex;
  align-items: center;
}
.priceSum {
  display: flex;
}
.headInfoHour {
  display: flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
  color: #ff8989;
}
.headInfoHour p {
  text-align: center;
}
.headInfoHour img {
  width: 24px;
}
.infoHour:nth-child(3) .headInfoHour {
  color: #2f2f2f;
}
.reservationButton {
  background-color: #2f2f2f;
  border-radius: 10px;
  border: 1px solid #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 600;
  color: #ffffff;
  padding: 10px;
  cursor: pointer;
}
.allQuestionnaires {
  width: 100%;
  background-color: #ff8989;
  color: #ffffff;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #ff8989;
  padding: 10px;
  cursor: pointer;
}
.aboutUs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  gap: 25px;
}
.mobileAboutUs {
  display: none;
  flex-direction: column;
  gap: 25px;
}
.mobileAboutUs div {
  background-color: #f6fafd;
  border-radius: 10px;
  padding: 5%;
  padding-top: 3%;
  line-height: 24px;
}
.aboutUs div {
  background-color: #f6fafd;
  border-radius: 10px;
  padding-left: 9%;
  padding-right: 11%;
  padding-top: 7%;
  padding-bottom: 7%;
  line-height: 24px;
  height: 100%;
}
.oneText {
  grid-area: 1 / 1 / 3 / 2;
  height: 100%;
}
.oneText p:nth-child(1) {
  font-size: 32px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 5%;
  padding-top: 6%;
  padding-bottom: 6%;
}
.oneText p:nth-child(2) {
  font-size: 18px;
  color: #757575;
}
.twoText {
  grid-area: 1 / 2 / 3 / 4;
  width: 100%;
  border-radius: 10px;
  height: 100%;
  object-fit: cover;
}
.threeText {
  grid-area: 3 / 1 / 4 / 2;
  height: fit-content;
}
.fourText {
  grid-area: 3 / 2 / 4 / 3;
  height: fit-content;
}
.fiveText {
  grid-area: 3 / 3 / 4 / 4;
  height: fit-content;
}
.aboutHeadText {
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 15px;
}
.aboutDescText {
  font-size: 18px;
  color: #757575;
}
.carousel__pagination-button::after {
  width: 2% !important;
  height: 2% !important;
  border-radius: 100px !important;
}
:deep(.carousel__pagination-button::after) {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
:deep(.carousel__pagination) {
  bottom: -7%;
}
.flicking-panel {
  align-items: flex-end;
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  height: 30vh;
  object-fit: cover;
  justify-content: flex-start;
  margin-bottom: 4vh;
  margin-right: 50px;
  padding: 0px 0px;
  position: relative;
  width: 30%;
  user-select: none;
  -webkit-user-drag: none;
  border-radius: 10px;
}
.citySelectWebApp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.cityList {
  height: 40vh;
  width: 100%;
  position: absolute;
  top: 110%;
  right: 0;
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  overflow-y: auto;
  padding: 2%;
  z-index: 5;
}
.cityList::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.cityList::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 8px;
}

.cityList::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.cityList p {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
  margin-left: 15px;
}
.cityList ul {
  padding-left: 0;
  list-style-type: none;
}
.cityList ul li {
  color: black;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.selectCityBlock {
  background-color: #fbfbfb;
  border-radius: 10px;
  padding: 5%;
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.selectCityBlockHead p {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 3%;
}
.selectCityBlockBody {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.selectCityInput {
  background-color: #fbfbfb;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid #2f2f2f;
  outline: none;
  font-size: 18px;
  color: #333333;
  cursor: pointer;
}
@media (max-width: 968px) {
  .listQuestionnaires {
    grid-template-columns: 1fr;
  }
  .aboutUs {
    display: none;
  }
  .mobileAboutUs {
    display: flex;
  }
  .main {
    margin-top: 5%;
    width: 80vw;
  }
  .aboutHeadText {
    font-size: 18px !important;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aboutDescText {
    font-size: 16px !important;
  }
  .oneText p {
    padding: 0 !important;
  }
  .flicking-panel {
    height: 20vh;
  }
}

@media (max-width: 1800px) {
  .main {
    width: 90vw;
  }
}
@media (max-width: 1200px) {
  .headInfoHour p {
    font-size: 14px;
  }
}
</style>
